import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { navigate, useStaticQuery, graphql } from 'gatsby';
import axios from 'axios';
import Icon from '../Icon';
import { theme } from '../../styles/GlobalStyles';

const FormWrap = styled.form`
  position: absolute;
  z-index: 10;
  right: 180px;
  margin: 3px 0;
  margin-right: 20px;
  transition-property: width, padding;
  transition-duration: 0.3s;
  width: ${props => (props.open ? '500px' : '15px')};
  background: ${props => (props.helpNavScroll > 0 && props.helpNavScroll < 400 ? `${theme.navbar.dark}` : `${theme.navbar.light}`)};
  
  .search-input {
    position: relative;
    width: calc(100% + 20px);
    min-width: 35px;
    min-height: 35px;
    background: rgba(255, 255, 255, 0.0001);
    border: 1px solid ${props => (props.helpNavScroll > 0 && props.helpNavScroll < 400 ? `${theme.body.dark}` : `${theme.body.light}`)};
    border-radius: 20px;
    svg {
      position: absolute;
      width: 100%;
      top: 0px;
      padding: 7px 10px 10px;
      width: 35px;
      height: 35px;
      fill: #FFFFFF;
      background: rgba(255, 255, 255, 0.001);
      outline: none;
      -webkit-tap-highlight-color: transparent;

      path {
        transition-delay: ${props => (props.toggleOpen ? '0.3s' : 'none')};
        fill: ${props => ((props.helpNavScroll > 0 && props.helpNavScroll < 400) || props.toggleOpen ? `${theme.body.dark}` : `${theme.body.light}`)};
      }
      :hover {
        cursor: pointer;
        outline: none;
      }
    }
    input {
      width: ${props => (props.open ? 'calc(100% - 30px)' : '0')};
      max-width: 500px;
      margin-left: 30px;
      padding-bottom: 7px;
      padding-top: 5px;
      font-size: 14px;
      background: rgba(255, 255, 255, 0.001);
      color: ${props => ((props.helpNavScroll > 0 && props.helpNavScroll < 400) || props.toggleOpen ? `${theme.body.dark}` : `${theme.body.light}`)};
      border: 0px;
      outline: none;
    }
  }

  @media(max-width: 989px) {
    margin-top: 1px;
    right: 50px;
    height: 0px;
    width: ${props => (props.open ? '50%' : '15px')};
  }
  @media(max-width: 767px) {
    margin-top: 1px;
    width: ${props => (props.open ? 'calc(100% - 110px)' : '15px')};
    .search-input {
      border: ${props => (props.open ? '1px' : '0px')} solid ${props => ((props.helpNavScroll > 0 && props.helpNavScroll < 400) || props.toggleOpen < 400 ? `${theme.body.dark}` : `${theme.body.light}`)};
    }
  }
`;

function HeaderSearchForm(props) {
  const {
    value,
    helpNavScroll,
    open,
    setOpen,
    toggleOpen,
  } = props;
  const [name, setName] = useState(value);

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            freshDesk {
              apiUrl,
              apiUser
            }
          }
        }
      }
    `
  );
  
  const handleSubmit = (evt) => {
    evt.preventDefault();
    navigate(`/help/search?term=${name}`, { state: { searchKey: name } });
    const searchApi = `${site.siteMetadata.freshDesk.apiUrl}/search/solutions?term=${name}`;
    axios.get(searchApi, {
      auth: {
        username: site.siteMetadata.freshDesk.apiUser,
        password: 'x'
      }
    }).then((response) => {
      const url = `/help/search?term=${name}`;
      navigate(url, { state: { data: response.data, searchKey: name }, hash: name, replace: true });
    });
  };
  return (
    <FormWrap
      onSubmit={handleSubmit}
      helpNavScroll={helpNavScroll}
      open={open}
      toggleOpen={toggleOpen}
    >
      <div className="search-input">
        <div onClick={() => setOpen(!open)} aria-hidden="true">
          <Icon name="search" color={helpNavScroll > 0 && helpNavScroll < 400 ? `${theme.body.dark}` : `${theme.body.light}`} />
        </div>
        <input
          type="text"
          id="headerSearchInput"
          value={name}
          placeholder="Search in help center"
          onChange={e => setName(e.target.value)}
          required
        />
      </div>
      <input type="submit" value="Submit" style={{ display: 'none' }} />
    </FormWrap>
  );
}

export default HeaderSearchForm;

HeaderSearchForm.propTypes = {
  value: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  toggleOpen: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  helpNavScroll: PropTypes.number.isRequired,
};

HeaderSearchForm.defaultProps = {
  toggleOpen: false,
};
